/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite, Timeline} from "gsap";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinterHoardTextStyles} from "../config/WinterHoardTextStyles";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";

export interface IWinterHoardSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    collect:ISymbolStateConfig;
    energy:ISymbolStateConfig;
    trigger:ISymbolStateConfig;
    landing:ISymbolStateConfig;
    plus:ISymbolStateConfig;
    idle:ISymbolStateConfig;
}

export class WinterHoardReelSymbol extends StateReelSymbol {

    private _energyOverlay:PIXI.Sprite | null;
    private _mpOverlay:PIXI.Sprite | null;
    private _mpLabel:PIXI.BitmapText | null;

    private _symSpine:PIXI.spine.Spine | null;
    private _m1EnergySpine:PIXI.spine.Spine | null;

    protected _idleAnimation:string;
    private _winAnimation:string;
    private _winAnimationDuration:number = 0;
    private _normalAnimation:string;
    private _winFlash:string;

    // M-symbol animations
    /**
     0: Animation {name: "m1_bg_energy", timelines: Array(61), duration: 1}
     1: Animation {name: "m1_bg_frame_energy", timelines: Array(74), duration: 1}
     2: Animation {name: "m1_landing", timelines: Array(99), duration: 0.5}
     3: Animation {name: "m1_normal", timelines: Array(70), duration: 0}
     4: Animation {name: "m1_win", timelines: Array(111), duration: 1}
     */


    private _m1BgFrameAnimation:string;
    private _m1LandingAnimation:string;
    private _m1BgEnergyAnimation:string;
    private _playingEnergy:boolean = false;

    private isTransformed:boolean = false;
    private _fsLevel:number = 0;
    private _collectedBefore:number = 0;
    private _collectedAfter:number = 0;



    get multiplier():number {
        return this._multiplier ? this._multiplier : 1;
    }

    set multiplier(value:number) {
        this._multiplier = value;
        if(!this.parent) return;

        if(this._multiplier > 1 && ["M1", "M2", "M3", "M4", "M5"].indexOf(this.symName) > -1) {
            if(!this._mpLabel) {
                this._mpLabel = new PIXI.BitmapText("x" + this._multiplier, WinterHoardTextStyles.MULTIPLIER_SYMBOL);
            }
            else {
                this._mpLabel.text = "x" + this._multiplier;
            }

            if(this._mpLabel){
                this.addChild(this._mpLabel);

                switch(this.symName) {
                    case "M1":
                    case "M5":
                    case "M2":
                        // on left
                        this._mpLabel.x = -70;
                        this._mpLabel.y = 15;
                        break;
                    default:
                        // on right
                        this._mpLabel.x = 15;
                        this._mpLabel.y = 15;
                    break;
                }
            }
        }
    }

    private _multiplier:number;
    private _multiplierTag:PIXI.Sprite;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations(reinit:boolean = false):void {
        const symName = (this.isTransformed)? "M1" : this.symName;
        this._playingEnergy = false;

        //console.log("SYMBOL CURRENT STATE: " + this._currentState?.keyword);

        if(this.isTransformed) {
            this._symSpine = null;
            //console.log("-----------------> RE-INITING SYM: " + this.symName);
        }

        // Create sym spines
        //if(reinit) {
            if (["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"].indexOf(symName) > -1 && !this._symSpine) {
                /*
                    0: Animation {name: "L4_idle", timelines: Array(21), duration: 1}
                    1: Animation {name: "L4_normal", timelines: Array(19), duration: 0}
                    2: Animation {name: "L4_win", timelines: Array(27), duration: 1}
                */
                this._symSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("symSpine" + symName));
                const animation: any = this._symSpine.skeleton.data.animations;

                if (["L1", "L2", "L3", "L4", "L5"].indexOf(symName) > -1) {
                    //console.log(animation);
                    this._winFlash = animation[0].name;
                    this._idleAnimation = animation[1].name;
                    this._normalAnimation = animation[2].name;
                    this._winAnimation = animation[3].name;

                    this.addChild(this._symSpine);
                    this.playSymSpine(this._normalAnimation, false);
                } else {
                    if (symName === "M1") {
                        /**
                         0: Animation {name: "m1_bg_energy", timelines: Array(61), duration: 1}
                         1: Animation {name: "m1_bg_frame_energy", timelines: Array(74), duration: 1}
                         2: Animation {name: "m1_flash", timelines: Array(62), duration: 0.5}
                         3: Animation {name: "m1_landing", timelines: Array(99), duration: 0.5}
                         4: Animation {name: "m1_normal", timelines: Array(70), duration: 0}
                         5: Animation {name: "m1_transform_to_meter", timelines: Array(71), duration: 0.666700005531311}
                         6: Animation {name: "m1_win", timelines: Array(111), duration: 1}
                         */

                        this._normalAnimation = animation[4].name;
                        this._winAnimation = animation[6].name;
                        this._winAnimationDuration = animation[6].duration;
                        this._m1BgFrameAnimation = animation[1].name;
                        this._m1LandingAnimation = animation[3].name;
                        this._m1BgEnergyAnimation = (this.isTransformed) ? this._normalAnimation : animation[5].name;
                        //this.playSymSpine(this._m1BgFrameAnimation, true, 1);
                        //this.playSymSpine(this._m1BgEnergyAnimation, true, 0);
                    } else {
                        //console.log(animation);
                        this._normalAnimation = animation[0].name;
                        this._winAnimation = animation[1].name;
                    }

                    if (symName === "M1" /*&& this._m1EnergySpine*/) {
                        //this.addChild(this._m1EnergySpine);
                        this.playM1SymSpine(this._normalAnimation);
                    }
                    this.addChild(this._symSpine);
                    this.playSymSpine(this._normalAnimation, false);
                }

                //console.log(animation);
            }
        //}
    }

    public playIdleSpine():void {
        if(this._symSpine && this.currentState && this.currentState.keyword !== WinterHoardGameConfig.instance.SYMBOL_STATES.noWin.keyword && this._idleAnimation) {
            this.playSymSpine(this._idleAnimation);
        }
    }

    private playSymSpine(name:string, loop:boolean = false, track:number = 0):void {
        if(this._symSpine && this._symSpine.state) {
            this._symSpine.state.setAnimation(track, name, loop);
        }
    }

    public playNormalSpine():void {
        if(this._symSpine && this._symSpine.state) {
            this._symSpine.state.setAnimation(0, this._normalAnimation, false);
        }
    }

    public playM1Tease():void {
        if(!this.parent) return;

        if((this.symName === "M1" || this.isTransformed) && this._symSpine) {
            this._symSpine.state.setAnimation(0, "m1_flash", false);
        }
    }

    private playM1SymSpine(name:string, loop:boolean = false, track:number = 0):void {

        if(name === this._m1BgEnergyAnimation) {
            this._playingEnergy = true;
        }

        if(this._m1EnergySpine && this._m1EnergySpine.state) {
            this._m1EnergySpine.state.setAnimation(track, name, loop);
        }
        else {
            this.playSymSpine(name, loop, track);
        }
    }

    private createEnergyOverlay():void {
        this._energyOverlay = new PIXI.Sprite();
        this._energyOverlay.scale.set(0.5, 0.5);
        this._energyOverlay.alpha = 0.75;
        //this._energyOverlay.anchor.set(0.5, 0.5);
        this._energyOverlay.position.set(-120, 0);
        this._energyOverlay.visible = false;

       // this.addChild(this._energyOverlay);
    }

    public showEnergy():Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add(() => {
            if(this._energyOverlay && !this.isTransformed && this._fsLevel < 5) {
                //this.playM1SymSpine(this._m1BgEnergyAnimation, true);
                //this._energyOverlay.visible = true;
            }
        });

        return tl;
    }

    // TODO: Probably only hiding the energy
    public collectEnergy(endPosition:PIXI.Point = new PIXI.Point()):Timeline {
        const tl:Timeline = new TimelineLite();

        if(this._energyOverlay) {
            //debugger;
            tl.add(() => {
                //this.playM1SymSpine(this._m1BgFrameAnimation);
            });
        }

        return tl;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(this.symName !== "M1" && this._playingEnergy) {
            this.playNormalSpine();
        }

        if(WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore >= 20) {
            this.playNormalSpine();
        }

        if(newState.state.keyword !== WinterHoardGameConfig.instance.SYMBOL_STATES.spin.keyword || this.symName === "M1") {
            this.initAnimations(true);
        }

        /*if(newState.state.keyword !== WinterHoardGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            if (this._symSpine) {
                this._symSpine.visible = true;
            }
        }*/
        /*else {
            if(this.multiplier > 1) {
                this.initAnimations(true);
            }
            //console.log("SKIPPING SPINES ON SYMBOLS!");
        }*/

        if(["M2", "M3", "M4", "M5"].indexOf(this.symName) > -1) {
            this.createEnergyOverlay();

            this._fsLevel = WinterHoardGameModuleConfig.symbolDataStopped.level;
            this._collectedAfter = WinterHoardGameModuleConfig.symbolDataStopped.collectedAfter;
            this._collectedBefore = WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore;
            this.isTransformed = WinterHoardGameModuleConfig.symbolDataStopped.determineTransform(this.symName);

            /*if(this.isTransformed) {
                this.initAnimations();
            }*/


            /*if(this.symName === "M1" && this.isTransformed && WinterHoardGameModuleConfig.symbolData.currentMode !== "") {
                //if(WinterHoardGameModuleConfig.symbolData.currentMode !== "FREESPIN_PICK") {
                this.playNormalSpine();
                //}
            }*/
        }

        //this.multiplier = 2;

        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.1, {x : 1, y : 1}));
            timeline.add(winTl, delay);
            timeline.add(() => {
                this.multiplier = WinterHoardGameModuleConfig.symbolDataStopped.determineMultiplier(this.symName);
            });
            return;
        }

        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.win.keyword) {
            const winTl:TimelineLite = new TimelineLite();

            if(["L1","L2","L3","L4","L5","M1","M2","M3","M4","M5"].indexOf(this.symName) > -1){
                winTl.add(() => {
                    if(this._winAnimation) {
                        this.playSymSpine(this._winAnimation);
                    }
                });

                this._fsLevel = WinterHoardGameModuleConfig.symbolDataStopped.level;
                this._collectedAfter = WinterHoardGameModuleConfig.symbolDataStopped.collectedAfter;
                this._collectedBefore = WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore;


                if(!this.isTransformed && this.symName === "M1" && this._fsLevel > -1 &&  (this._collectedBefore < 20)) {
                    //if(WinterHoardGameModuleConfig.symbolData.currentMode !== "FREESPIN_PICK") {
                    if(this._collectedAfter >= 20) {
                        //debugger;
                    }
                   winTl.add(() => {
                       //console.log("PLAYING ENERGY on SYM: " + this.symName + " fsLevel: " + this._fsLevel);
                       if(WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore < 20 || WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers.M1 === 4) {
                           this.playM1SymSpine(this._m1BgEnergyAnimation, false);
                       }
                   }, this._winAnimationDuration);
                    //}
                }
            }
            else {
                winTl.add(new TweenLite(this.scale, 0.2, {x: 1.2, y: 1.2}));
                winTl.add(new TweenLite(this.scale, 0.2, {x: 1, y: 1, delay: 0.3}));
            }


            timeline.add(winTl, delay);
            this.multiplier = WinterHoardGameModuleConfig.symbolDataStopped.determineMultiplier(this.symName);
            return;
        }

        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.noWin.keyword) {

            if(this._symSpine) {
                this._symSpine.tint = 0x555555;
            }

            this.multiplier = WinterHoardGameModuleConfig.symbolData.determineLastMultiplier(this.symName);

            if(this._mpLabel) {
                this._mpLabel.tint = 0x555555;
            }
            return;
        }

        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.energy.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            //winTl.add(new TweenLite(this.scale, 0.2, {x : 1.2, y : 1.2}));
            //winTl.add(new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            timeline.add(winTl, delay);
            return;
        }

        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.collect.keyword) {
            const winTl:TimelineLite = new TimelineLite();
            winTl.add(new TweenLite(this.scale, 0.2, {x : 1.2, y : 1.2}));
            winTl.add(new TweenLite(this.scale, 0.2, {x : 1, y : 1, delay : 0.3}));
            timeline.add(winTl, delay);
            return;
        }
        if(this._currentState?.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.spin.keyword &&
            newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.spin.keyword) {

            this.isTransformed = WinterHoardGameModuleConfig.symbolData.determineTransform(this.symName);
            if(this._fsLevel === 0 && this.symName === "M5") {
                //debugger;
            }
            if(this.isTransformed) {
                this.initAnimations(true);
            }

            /*if(this._symSpine && this.isTransformed) {
                this._symSpine.visible = false;
            }*/

            timeline.add(() => {
                this.multiplier = WinterHoardGameModuleConfig.symbolDataStopped.determineMultiplier(this.symName);
                this._fsLevel = WinterHoardGameModuleConfig.symbolDataStopped.level;
                this._collectedAfter = WinterHoardGameModuleConfig.symbolDataStopped.collectedAfter;
                this._collectedBefore = WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore;



                if(!this.isTransformed && this.symName === "M1" && this._fsLevel > -1  &&  (this._collectedBefore < 20)) {
                    //if(WinterHoardGameModuleConfig.symbolData.currentMode !== "FREESPIN_PICK") {

                        //console.log("PLAYING ENERGY on SYM: " + this.symName + " fsLevel: " + this._fsLevel);
                        if(WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore < 20 || WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers.M1 === 4) {
                            this.playM1SymSpine(this._m1BgEnergyAnimation, true);
                        }
                    //}
                }
            });
            //this.multiplier = WinterHoardGameModuleConfig.symbolData.determineMultiplier(this.symName);
            return;
        }
    }
}